import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { checkPermissionGet } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { useNavigate } from 'react-router-dom';
const WithAuthAadhar = (WrappedComponent) => {
    const AuthWrapper = () => {
        const navigate = useNavigate();
        const [regStatus, setRegStatus] = useState('');
        const kycStatus = localStorage.getItem('kycKeyStatus');
        const componentName = WrappedComponent.displayName || WrappedComponent.name || '';
        const isAadhaarPay = componentName === 'AadhaarPay';
        // console.log('kycStatus', kycStatus);
        // console.log(typeof kycStatus);
        const statusCheckFunctions = (status) => {
            if (status === 'SUCCESS') {
                if (kycStatus === '0') {
                    // console.log('kycStatus', kycStatus);
                    if (isAadhaarPay) {
                        return <Navigate to="/aadhaarpay/kycauthentication" />;
                    } else {
                        return <Navigate to="/aeps/kycauthentication" />;
                    }
                } else {
                    return <WrappedComponent />;
                }
            }
            if (status === 'PENDING') {
                return <Navigate to="/pending-section" />;
            }
            if (status === 'register') {
                if (isAadhaarPay) {
                    return <Navigate to="/aadhaarpay/iciciregistration" />;
                } else {
                    return <Navigate to="/aeps/iciciregistration" />;
                }
            }
        };
        if (regStatus) {
            return statusCheckFunctions(regStatus);
        }
        checkPermissionGet()
            .then((responsePermission) => {
                const response = responsePermission?.data;
                if (response?.AEPS === 'iserveu') {
                    // setRegStatus(response?.iserveuStatus);
                    if (response?.iserveuStatus === '') {
                        navigate('/matm/iserveu-matm-registration');
                    } else {
                        setRegStatus(response?.iserveuStatus);
                    }
                } else {
                    if (response?.icicStatus === '') {
                        setRegStatus('register');
                    } else {
                        setRegStatus(response?.icicStatus);
                    }
                    // setRegStatus(response?.icicStatus);
                }
            })
            .catch((error) => console.log('error', error));
        // const icicStatus = localStorage.getItem('matm');
    };
    return AuthWrapper;
};

export default WithAuthAadhar;
